import {defineField, defineType} from 'sanity'
import {MdTitle} from 'react-icons/md'

export default defineType({
  name: 'page.title',
  title: 'Page Title',
  type: 'object',
  icon: MdTitle,
  fields: [
    defineField({
      name: 'title',
      type: 'text',
    }),
    defineField({
      name: 'subtitle',
      type: 'text',
    }),
    defineField({
      name: 'titleVariant',
      title: 'Title Variant',
      type: 'string',
      options: {
        list: [
          {title: 'Centered', value: 'centered'},
          {title: 'Left', value: 'left'},
        ],
        layout: 'radio',
      },
      initialValue: 'left',
    }),
  ],
  preview: {
    select: {
      title: 'title',
      subtitle: 'subtitle',
    },
  },
})
